import { ComponentEnum, isSupportedComponentType } from "../../../types";

export interface ComponentGroup {
  title: string;
  components: ComponentEnum[];
  variableGroups: string[][];
}

export const COMPONENT_GROUPS: ComponentGroup[] = [
  {
    title: "Input Group",
    components: [
      ComponentEnum.INPUT,
      ComponentEnum.MULTIPLE_CHOICE,
      ComponentEnum.USER_LIST,
      ComponentEnum.PRIORITY_LIST,
      ComponentEnum.RATING_SCALE,
      ComponentEnum.DATE_TIME,
    ],
    variableGroups: [["variable"], ["label"]],
  },
  {
    title: "Media Group",
    components: [
      ComponentEnum.VIDEO,
      ComponentEnum.TEXT,
      ComponentEnum.TOGGLE_TEXT,
      ComponentEnum.IMAGE,
      ComponentEnum.CALLOUT_BOX,
    ],
    variableGroups: [
      ["transcript", "text", "body", "definition"],
      ["title", "word"],
      ["src", "image_src"],
      ["alt", "image_alt"],
    ],
  },
  {
    title: "Links Group",
    components: [ComponentEnum.CUSTOM_LINK, ComponentEnum.LESSON_LINK],
    variableGroups: [["button_text", "label"]],
  },
  {
    title: "Calendar",
    components: [ComponentEnum.ADD_TO_CALENDAR],
    variableGroups: [["eventTitle"], ["description"]],
  },
  {
    title: "Other Components",
    components: [
      ComponentEnum.LOGIC_COMPONENT,
      ComponentEnum.FOR_EACH,
      ComponentEnum.TOGGLE,
    ],
    variableGroups: [["componentsList"]],
  },
];

export const DISPLAY_VARIABLES_MINIMIZED = {
  [ComponentEnum.INPUT]: ["label", "variable"],
  [ComponentEnum.MULTIPLE_CHOICE]: ["label", "variable"],
  [ComponentEnum.USER_LIST]: ["label", "variable"],
  [ComponentEnum.PRIORITY_LIST]: ["label", "variable"],
  [ComponentEnum.RATING_SCALE]: ["label", "variable"],
  [ComponentEnum.DATE_TIME]: ["label", "variable"],
  [ComponentEnum.VIDEO]: ["url"],
  [ComponentEnum.TEXT]: [],
  [ComponentEnum.TOGGLE_TEXT]: ["title"],
  [ComponentEnum.IMAGE]: ["alt"],
  [ComponentEnum.ACTION_DETAIL]: ["label"],
  [ComponentEnum.CUSTOM_LINK]: ["button_text"],
  [ComponentEnum.LESSON_LINK]: ["label"],
  [ComponentEnum.LOGIC_COMPONENT]: [],
  [ComponentEnum.CALLOUT_BOX]: ["word", "definition"],
  [ComponentEnum.FOR_EACH]: ["parsingVariable"],
  [ComponentEnum.TOGGLE]: ["title"],
  [ComponentEnum.ADD_TO_CALENDAR]: ["eventTitle"],
};

export const getComponentGroup = (
  componentType: string,
): ComponentGroup | null => {
  if (!isSupportedComponentType(componentType)) {
    return null;
  }
  return (
    COMPONENT_GROUPS.find((group) =>
      group.components.includes(componentType as ComponentEnum),
    ) || null
  );
};
